__turbopack_context__.v({
  "listingMessageModal": "listing-message-modal-module-scss-module__t7fF6W__listingMessageModal",
  "listingMessageModal_card": "listing-message-modal-module-scss-module__t7fF6W__listingMessageModal_card",
  "listingMessageModal_details": "listing-message-modal-module-scss-module__t7fF6W__listingMessageModal_details",
  "listingMessageModal_listingTitle": "listing-message-modal-module-scss-module__t7fF6W__listingMessageModal_listingTitle",
  "listingMessageModal_title": "listing-message-modal-module-scss-module__t7fF6W__listingMessageModal_title",
});
